import styled from 'styled-components';
import { Palette } from 'config';

export const Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background: ${Palette.White._000};
  padding: 16px 16px 16px 24px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
`;

export const HeaderTitle = styled.h2`
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  color: ${Palette.PrimaryGray._900};
  margin: 0;
`;
